export default __webpack_public_path__ + "static/media/proj1_7.e4a4acf7.jpg";